import axios, {
  AxiosInstance,
  AxiosError,
  InternalAxiosRequestConfig,
} from 'axios';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import useAuthStore from '../store/Auth';

const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return (decoded.exp ?? 0) < currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return true;
  }
};

const WebAppAPI = (): AxiosInstance => {
  const authToken = localStorage.getItem('authToken');
  const baseURL = process.env.REACT_APP_ACCESS_CODE_URL;

  const axiosInstance: AxiosInstance = axios.create({
    baseURL,
    timeout: 30000,
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
  });

  axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = localStorage.getItem('authToken');

      if (token && isTokenExpired(token)) {
        useAuthStore.getState().logout();
        return Promise.reject(new Error('Token expired'));
      }

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error: AxiosError) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        useAuthStore.getState().logout();
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default WebAppAPI;
